var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataForm,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 11
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保险特点"),
      prop: "feature"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("多保险特点用“,”隔开")
    },
    model: {
      value: _vm.dataForm.feature,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "feature", $$v);
      },
      expression: "dataForm.feature"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("理赔流程")
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor",
    staticStyle: {
      height: "540px"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.dataForm.claimsProcess,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "claimsProcess", $$v);
      },
      expression: "dataForm.claimsProcess"
    }
  })], 1), _vm._l(_vm.dataForm.copywriting, function (item, index) {
    return _c("a-form-model-item", {
      key: index,
      attrs: {
        label: item.name
      }
    }, [_c("div", {
      staticClass: "copywritingItem"
    }, [_c("quill-editor", {
      ref: "myTextEditor" + index,
      refInFor: true,
      staticStyle: {
        height: "540px",
        width: "100%"
      },
      attrs: {
        options: _vm.quillOption
      },
      model: {
        value: item.content,
        callback: function ($$v) {
          _vm.$set(item, "content", $$v);
        },
        expression: "item.content"
      }
    }), _c("div", {
      staticClass: "desBox",
      staticStyle: {
        "flex-direction": "column"
      }
    }, [_c("a-button", {
      staticStyle: {
        width: "66px",
        "margin-top": "10px"
      },
      attrs: {
        type: "danger"
      },
      on: {
        click: function ($event) {
          return _vm.dataForm.copywriting.splice(index, 1);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("删除")))])], 1)], 1)]);
  }), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 11,
        offset: 2
      }
    }
  }, [_c("a-button", {
    staticStyle: {
      width: "100%",
      height: "40px",
      "font-size": "16px"
    },
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: _vm.addCopywritingFun
    }
  }, [_vm._v(_vm._s(_vm.$t("添加") + _vm.$t("文案模块")))])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品主图")
    }
  }, [_c("a-upload", {
    attrs: {
      "list-type": "picture-card",
      action: _vm.uploadFile,
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      data: {
        module: "customerInsurance"
      },
      "file-list": _vm.fileList,
      "before-upload": _vm.beforeUpload,
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      }
    },
    on: {
      change: file => _vm.handleChange(file),
      preview: _vm.handlePreview
    }
  }, [!_vm.dataForm.coverUrl ? _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loading ? "loading" : "plus"
    }
  })], 1) : _vm._e()]), _c("span", [_vm._v("* " + _vm._s(_vm.$t("仅支持上传jpg,jpeg,png格式图片，图片大小不超500KB")))])], 1)], 2), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        return _vm.$emit("previous");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.saveLoading
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1), _vm.copywritingShow ? _c("copywriting-model", {
    ref: "copywritingFrom",
    on: {
      cancel: function ($event) {
        _vm.copywritingShow = false;
      },
      ok: _vm.copywritingHandleOk
    }
  }) : _vm._e(), _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      footer: null,
      width: 800
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }, [_c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      src: _vm.previewImage
    }
  })])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };